import { render, staticRenderFns } from "./BottomBlock.vue?vue&type=template&id=360187fa&scoped=true"
import script from "./BottomBlock.vue?vue&type=script&lang=js"
export * from "./BottomBlock.vue?vue&type=script&lang=js"
import style0 from "./BottomBlock.vue?vue&type=style&index=0&id=360187fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360187fa",
  null
  
)

export default component.exports